// extracted by mini-css-extract-plugin
export default {"wrapper":"Wrapper-module--wrapper--f5573"};